import type { ComponentProps } from "react";
import { Input } from "@acdc2/ui/components/input";
import { useTranslation } from "react-i18next";
import { ValueMissingFormMessage } from "../../ui/forms";
import {
  FormControl,
  FormField,
  FormHelpText,
  FormLabel,
} from "@acdc2/ui/components/access-form";

type Props = ComponentProps<typeof Input>;

export function ListItemFormField(props: Props) {
  const { t } = useTranslation();

  return (
    <FormField name="listItem">
      <FormLabel>{t("ListItemFormField.label")}</FormLabel>
      <FormControl asChild>
        <Input type="number" inputMode="numeric" min={0} required {...props} />
      </FormControl>
      <ValueMissingFormMessage />
      <FormHelpText>{t("ListItemFormField.help")}</FormHelpText>
    </FormField>
  );
}
